import React, { useEffect, useState } from 'react';
import PageHeader from '../../shared/page-header/PageHeader';
import ColorModal from './ColorModal';
import ColorGrid from './ColorGrid';
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts';
import axios from 'axios';
import { getStorageValues } from '../../shared/CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';
import { getModulePermissions } from '../../utils/permissionHelper';
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles';
import { logAuditEvent } from '../../utils/auditLogger';

function ColorMain(props) {
  const [colorList, setColorList] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [alert, setAlert] = useState(null);
  const [userModulePermission, setUserModulePermission] = useState({});
  const moduleName = props.Module || 'Color';

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module);
    setUserModulePermission(modulePermissions ? modulePermissions : []);
    fetchColors();
  }, [props.Module]);

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', 'Accessed Color module');
  }, [moduleName]);

  const openAddModal = () => {
    setIsOpen(true);
    logAuditEvent(moduleName, 'Add Button Click', 'Opened add color modal');
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const validation = (payload) => {
    if (!payload || !payload.ColorName || !payload.ColorName.trim()) {
      CreateAlert('Please enter color name!!', 'Warning', setAlert);
      return false;
    }
    return true;
  };

  const onSubmit = async (e, data) => {
    if (e.target.name === 'Add') {
      const payload = {
        ColorId: null,
        ColorName: data?.ColorName ? data.ColorName.trim() : '',
        ColorCode: data?.ColorCode || '',
        Description: data?.Description || '',
        UserId: getStorageValues('userId'),
      };
      if (!validation(payload)) {
        return;
      }
      try {
        const response = await axios.post(`${getApiBaseUrl()}/saveColorDetails`, payload);
        if (response.status === 200) {
          const responseData = response.data?.data;
          const result = Array.isArray(responseData) ? responseData[0] : responseData;
          if (result?.success === 1) {
            CreateAlert(result.message || 'Color added successfully!!', 'Success', setAlert);
            fetchColors();
            closeModal();
          } else {
            CreateAlert(result?.message || 'Color already exists!!', 'Error', setAlert);
          }
        }
      } catch (error) {
        console.error(error);
        CreateAlert('Failed to add color!!', 'Error', setAlert);
      }
    }
  };

  const fetchColors = async () => {
    try {
      const response = await axios.get(`${getApiBaseUrl()}/colorlist`, {
        params: { UserId: getStorageValues('userId') },
      });
      if (response.status === 200) {
        setColorList(response.data.data[0] || []);
      }
    } catch (error) {
      console.error(error);
      CreateAlert('Failed to load colors!!', 'Error', setAlert);
    }
  };

  const handleExportExcel = () => {
    const columns = [
      { name: 'Color Name', selector: 'ColorName' },
      { name: 'Color Code', selector: 'ColorCode' },
      { name: 'Description', selector: 'Description' },
    ];
    exportToExcel('Colors', columns, colorList);
  };

  const handleExportPDF = () => {
    const columns = [
      { name: 'Color Name', selector: 'ColorName' },
      { name: 'Color Code', selector: 'ColorCode' },
      { name: 'Description', selector: 'Description' },
    ];
    exportToPDF('Colors', columns, colorList);
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onModelOpen={openAddModal}
        onRefresh={fetchColors}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={userModulePermission.AddModule === 1}
      />
      <ColorGrid
        ColorData={colorList}
        fetchColors={fetchColors}
        UserPermissions={userModulePermission}
        moduleName={moduleName}
      />
      <ColorModal
        show={modalIsOpen}
        UserAction="Add"
        onClose={closeModal}
        onSubmit={onSubmit}
        moduleName={moduleName}
      />
    </>
  );
}

export default ColorMain;
